export default __webpack_public_path__ + "static/media/Dialog.711475dd.svg";